import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-edit-note',
  templateUrl: './edit-note.component.html',
  styleUrls: ['./edit-note.component.scss'],
})
export class EditNoteComponent implements OnInit, AfterViewInit {
  @Input() elementData: { value: string };
  @Output() hideDialog: EventEmitter<any> = new EventEmitter();
  @Output() cancelDialog: EventEmitter<any> = new EventEmitter();

  noteMaxLength = 250;
  valueCtrl = new FormControl('', [Validators.required, Validators.maxLength(this.noteMaxLength)]);
  emojiListDialogRef: MatDialogRef<any>;

  @ViewChild('inputElement') private inputElement: ElementRef;
  @ViewChild('emojiListTemplateRef') private emojiListTemplateRef: TemplateRef<any>;
  @ViewChild('templateRef') private templateRef: TemplateRef<any>;

  constructor(private basicService: BasicService, private dialog: MatDialog) {}

  ngOnInit() {
    this.valueCtrl.setValue(this.elementData.value);
  }

  ngAfterViewInit(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: ['large-size'],
      autoFocus: false,
      data: {
        title: this.basicService.translate('parameters/quick_replies/details/graph/note/edit-description/title'),
        confirmBtnText: this.basicService.translate('save'),
        cancelBtnText: this.basicService.translate('cancel'),
        templateRef: this.templateRef,
        disable: () => this.valueCtrl.invalid,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const { value } = this.valueCtrl;
        this.hideDialog.emit({ type: 'ok', data: { value } });
      } else {
        this.cancelDialog.emit();
      }
    });
  }

  selectEmoji(): void {
    this.emojiListDialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: ['large-size'],
      autoFocus: false,
      data: {
        title: this.basicService.translate(
          'parameters/quick_replies/details/graph/note/edit-description/add-emoji/title'
        ),
        templateRef: this.emojiListTemplateRef,
      },
    });
    this.emojiListDialogRef.afterClosed().subscribe(emoji => {
      if (emoji) {
        const element = this.inputElement.nativeElement;
        const start = element.selectionStart || 0;
        const end = element.selectionEnd || 0;
        const { value } = this.valueCtrl;
        this.valueCtrl.setValue(`${(value || '').slice(0, start)}${emoji}${(value || '').slice(end)}`);
        setTimeout(() => {
          element.selectionStart = element.selectionEnd = +start + +emoji.length;
          element.focus();
        }, 0);
      }
    });
  }
}
